import { useMemo, useState } from 'react';

export type Pagination<T> = {
  page: number;
  pageItems: T[];
  onChangePage: (page: number) => void;
};

export const usePagination = <T>(items: T[], pageSize: number): Pagination<T> => {
  const [requestedPage, setRequestedPage] = useState(1);

  // A lista pode encolher (busca, remoção): a página pedida nunca passa da última.
  const lastPage = Math.max(1, Math.ceil(items.length / pageSize));
  const page = Math.min(requestedPage, lastPage);

  const pageItems = useMemo(() => {
    const start = (page - 1) * pageSize;
    return items.slice(start, start + pageSize);
  }, [items, page, pageSize]);

  return { page, pageItems, onChangePage: setRequestedPage };
};
